<template>
  <div class="programme">
    <!--  可视化云屏-->
    <div class="banner">
      <img :src=cloudOne.topPhotos  width="100%" height="300px">
      <div class="wrap">
        <h1>{{ cloudOne.title }}</h1>
      </div>
    </div>
    <div class="linkbanner">
      <el-link type="danger" @click="index">首页</el-link>
      <i class="el-icon-arrow-right"></i>
      <el-link type="danger"  @click="next">云仓</el-link>
      <i class="el-icon-arrow-right"></i>
      <el-link type="info">{{ cloudOne.title }}</el-link>
    </div>
    <div class="wrap">
      <div class="shopping">
          <div class="money">¥<span>{{  parseFloat(cloudOne.price).toFixed(2)}}</span></div>
        <div class="cay">
          <div v-for="(item,index) in caylist" :key="index">
            <img :src="require('../../../assets/'+item.img)">
            <span>{{item.name}}</span>
          </div>
        </div>
      </div>
      <div v-html="cloudOne.detail">

      </div>
    </div>
  </div>
</template>

<script>
import newService from "@/api/newService";

export default {
  name: "programmeOne",
    created() {
      this.getCloudOne()
    },
    data(){
    return {

      cloudOne:{},
      bannerimg:"Yuncang1/Yuncang1.png",
      bannerimg2:"Yuncang1/Yuncang7.png",
      bannerimg3:"Yuncang1/Yuncang8.png",
      caylist:[{
        img:'Yuncang1/Yuncang4.png',
        name:'银联支付'
      },{
        img:'Yuncang1/Yuncang5.png',
        name:'微信支付'
      },{
        img:'Yuncang1/Yuncang6.png',
        name:'支付宝支付'
      }]
    }
  },
  methods:{
    index(){
      this.$store.state.components='home'
    },
    next(){
      this.$store.state.components='Yuncang'
    },
      getCloudOne(){
          const id = localStorage.getItem('cloudId');
          newService.getCloudOne(id).then((res)=>{
              this.cloudOne=res
          })
      }
  }
}
</script>

<style lang="less" scoped>
.programme{
  .linkbanner{
    width: 118rem;
    height: 4.8rem;
    display: flex;
    align-items: center;
    margin: auto;
    background: #F8F8F8;
    box-shadow: 0px 1px 0px 0px #E5E5E5;
    padding-left: 2rem;
    font-size: 1.6rem;
    /deep/.el-link--inner{
      font-size: 1.6rem;
    }
    .el-link.el-link--danger{
      color: #ED0200;
      font-size: 1.6rem;
    }
    i{
      margin: 0px 5px;
      font-size: 1.6rem;
      padding-top: 1px;
    }
  }
  .banner{
    display: block;
    overflow: hidden;
    position: relative;
    width: 120rem;
    min-width: 120rem;
    margin: 6.4rem auto 0;
    img{display: block}
    .wrap{
      width: auto;
      position: absolute;
      top: 6rem;
      left:  0rem;
      z-index: 1;
      color: #fff;
      margin: 0;
      h1{
        font-size: 7.6rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        letter-spacing: .8rem;
        margin-left: 10rem;
      }
      h2{
        font-size: 2.8rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        margin-left: 10rem;
      }
    }
  }
  .wrap{
    width: 120rem;
    display: block;
    margin:15rem auto;
    .shopping{
      height: 12rem;
      background: url('../../../assets/Yuncang1/Yuncang3.png') no-repeat center center;
      background-size: 100% 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      align-items: center;
      margin-bottom: 8rem;
      margin-top: -8rem;
      position: relative;
      &::after{
        content: '';
        position: absolute;
        width: 8rem;
        height: 5.3rem;
        background:url('../../../assets/Yuncang1/Yuncang2.png') no-repeat center center;
        background-size: 100% 100%;
        left: 1rem;
        top: -2rem;
      }
      .money{
        width: 48rem;
        text-align: center;
        font-size: 4rem;
        color: #fff;
        span{
          font-size: 6rem;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
        }
      }
      .cay{
        width: 58rem;
        display: flex;
        justify-content: center;
        div{
          width: 33%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          img{height: 3.6rem}
          span{margin-top:1rem }
        }
      }
    }
    h3{
      font-size: 2.8rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 2.8rem;
      margin-bottom: 3.2rem;
    }
    h4{
      font-size: 1.6rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      margin-bottom: 10.0rem;
      color: #444955;
      line-height: 4.0rem;
    }
    .programmeOne-box{
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: center;
      text-align: center;
      margin: 6.0rem auto;
      div{
        width: 18.0rem;
        height: 26.0rem;
        margin-left: .5rem;
        margin-right: .5rem;
        background: #FFFEFF;
        box-shadow: 0rem .2rem .8rem 0rem rgba(0,0,0,0.2);
        border-radius: .4rem;
        margin-bottom: 4.0rem;
        font-size: 1.8rem;
        font-family: PingFangSC-Medium, PingFang SC;
        padding: 2.0rem;
        font-weight: 500;
        color: #333333;
        line-height: 2;

        img{
          width: 2.4rem;
          height: 2.4rem;
          margin-right: .5rem;
        }
        h5{
          margin: 0;
          line-height: 2.0rem;
        }
        span{
          display: flex;
          margin-bottom: 2.0rem;
        }
        em{
          font-style: normal;
          font-size: 1.6rem;
        }
      }
    }
  }
}
</style>
